const {resolveItemEdition} = require('./editions.cjs')

const key = (id, edition) => JSON.stringify([edition, id])

// Preserve the server's hierarchy and question references without merging editions.
function aggregateAssessmentStandards(standards = [], expectations = [], indicators = []) {
  const standardEdition = new Map()
  for (const standard of standards) {
    const id = standard.id
    const editions = standardEdition.get(id) || new Set()
    editions.add(resolveItemEdition(standard))
    standardEdition.set(id, editions)
  }

  const expectationEditions = new Map()
  for (const expectation of expectations) {
    const edition = expectation.standard_set
      ? resolveItemEdition(expectation)
      : (standardEdition.get(expectation.standard)?.size === 1
          ? [...standardEdition.get(expectation.standard)][0]
          : resolveItemEdition(expectation))
    const editions = expectationEditions.get(expectation.id) || new Set()
    editions.add(edition)
    expectationEditions.set(expectation.id, editions)
  }

  const parsedIndicators = new Map()
  const assessmentIndicators = {}
  for (const indicator of indicators) {
    const edition = indicator.standard_set
      ? resolveItemEdition(indicator)
      : (expectationEditions.get(indicator.expectation)?.size === 1
          ? [...expectationEditions.get(indicator.expectation)][0]
          : resolveItemEdition(indicator))
    const enriched = {...indicator, standard_set:edition}
    const lookup = key(indicator.expectation, edition)
    if (!parsedIndicators.has(lookup)) parsedIndicators.set(lookup, [])
    parsedIndicators.get(lookup).push(enriched)
    for (const reference of indicator.references || []) {
      if (!assessmentIndicators[reference.id]) assessmentIndicators[reference.id] = []
      assessmentIndicators[reference.id].push(enriched)
    }
  }

  const parsedExpectations = new Map()
  for (const expectation of expectations) {
    const edition = expectation.standard_set
      ? resolveItemEdition(expectation)
      : (standardEdition.get(expectation.standard)?.size === 1
          ? [...standardEdition.get(expectation.standard)][0]
          : resolveItemEdition(expectation))
    const lookup = key(expectation.standard, edition)
    if (!parsedExpectations.has(lookup)) parsedExpectations.set(lookup, [])
    parsedExpectations.get(lookup).push({
      ...expectation,
      standard_set:edition,
      indicators:parsedIndicators.get(key(expectation.id, edition)) || []
    })
  }

  return {
    standards: standards.map(standard => {
      const edition = resolveItemEdition(standard)
      return {...standard, standard_set:edition, expectations:parsedExpectations.get(key(standard.id, edition)) || []}
    }),
    assessmentIndicators
  }
}

module.exports = {aggregateAssessmentStandards}
